import React from 'react';

import { faCheckCircle, faHeadset } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';

import { saveCallSupportDetails, supportReply } from '../../../slices/LeoSlice';
import { AppDispatch } from '../../../types';
import { cn } from '../../../utils/classUtils';
import { CallSupportDetails, UserIntentEnum } from '../../../utils/LeoUtils';
import Button from '../../Button';

interface NeoLeoCallSupportMsgProps {
  session_id: string;
  callSupportDetails: CallSupportDetails;
}

enum ActionEnum {
  CALL_SUPPORT = 'CALL_SUPPORT',
  NO_ACTION = 'NO_ACTION',
}

const NeoLeoCallSupportMsg: React.FC<NeoLeoCallSupportMsgProps> = ({
  session_id,
  callSupportDetails,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [actionTaken, setActionTaken] = React.useState<ActionEnum>();
  const isCalledSupport = actionTaken === ActionEnum.CALL_SUPPORT;
  const isNoAction = actionTaken === ActionEnum.NO_ACTION;

  const handleCallSupport = async () => {
    dispatch(saveCallSupportDetails(callSupportDetails));
    setActionTaken(ActionEnum.CALL_SUPPORT);
    await dispatch(supportReply(UserIntentEnum.SUPPORT_SELECTED, session_id));
  };

  const stopCallSupport = async () => {
    setActionTaken(ActionEnum.NO_ACTION);
    await dispatch(supportReply(UserIntentEnum.SUPPORT_DISMISSED, session_id));
  };

  return (
    <div data-testid='call-support-msg'>
      <p className='mb-2'>Do you still want to call support?</p>
      <div className='flex-column space-y-2 items-center justify-center'>
        {(!actionTaken || isCalledSupport) && (
          <Button
            leftIcon={
              <FontAwesomeIcon
                icon={isCalledSupport ? faCheckCircle : faHeadset}
                className={cn(
                  isCalledSupport ? 'text-reskin-regent-600' : 'text-white',
                )}
                size='sm'
              />
            }
            onPress={handleCallSupport}
            isDisabled={isCalledSupport}
            variant='primary-outline'
            fullWidth
            label='Call support'
            data-testid='call-support-button'
          />
        )}
        {(!actionTaken || isNoAction) && (
          <Button
            leftIcon={
              <FontAwesomeIcon
                icon={faCheckCircle}
                className='text-reskin-regent-600'
                size='sm'
              />
            }
            onPress={stopCallSupport}
            isDisabled={isNoAction}
            variant='primary-outline'
            fullWidth
            label="No, I'm good"
          />
        )}
      </div>
    </div>
  );
};

export default NeoLeoCallSupportMsg;
